import { PaymentMethodInfo } from "./payment-method-info";

export class IBANPaymentInfo extends PaymentMethodInfo {
  AccountHolder: string;
  IBANNumber: string;
  BICNumber: string;
  FinancialInstitution:string;
  AccountHolderTaxId: string;
}
